const tokenTypes = {
  bearer: 'Bearer ',
};

export default tokenTypes;
